import axios, { CancelToken } from 'axios';
import { IPeriodoReprocessar } from '../../../../pages/ConfiguracoesReceitas/interface';
import { getToken } from "../../../token";
import { GATEWAY_API_URL } from '../../../request/urls';

class GerenciarMunicipiosService {
    async getGerenciarMunicipios(signal?: CancelToken) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/municipios`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            },
            cancelToken: signal
        });

        return data;
    }

    async getDetalhesMunicipio(id_ibge: number, sistema_slug: string) {
        const { data } = await axios.get(`${GATEWAY_API_URL}/receitas-ipm/municipios/${sistema_slug}/${id_ibge}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            }
        });

        return data;
    }

    async deleteMunicipio(id_ibge: number, sistema_slug: string) {
        const { data } = await axios.delete(`${GATEWAY_API_URL}/receitas-ipm/municipios/${sistema_slug}/${id_ibge}`, {
            headers: {
                'Authorization': 'Bearer ' + getToken(),
            }
        });

        return data;
    }

    async reprocessarMunicipio(id_ibge: number, sistema_slug: string, periodos: IPeriodoReprocessar[]) {
        const { data } = await axios.post(`${GATEWAY_API_URL}/receitas-ipm/municipios/${sistema_slug}/${id_ibge}/reprocessar`,
            { periodos },
            {
                headers: {
                    'Authorization': 'Bearer ' + getToken(),

                }
            }
        );

        return data;
    }
}

export default new GerenciarMunicipiosService();
